<div class="p-3">
  <h1 mat-dialog-title class="CenterAlign">About Release</h1>
  <div>
    <table class="tblAbout table" aria-labelledby ="About Release Information">
      <tr><th class="rightPadding">Version</th><td>{{data.Version}}</td></tr>
      <tr><th class="rightPadding">Build Number</th><td>{{data.BuildNumber}}</td></tr>
      <tr><th class="rightPadding">Build Date</th><td>{{data.DateOfBuild}}</td></tr>
    </table>
    <br>
  </div>
  <div mat-dialog-actions class="CenterAlign">
    <button mat-button mat-dialog-close cdkFocusInitial class="closeBtn actionBtn">Close</button>
  </div>
</div>

